var $ = require("jquery");

function habilitaMascara() {
	$("[data-mascara]").each(function(i, el) {
		$(el).mask($(el).data('mascara'));
	});
}

$(document).ready(function() {
	$('.box-logo .procura .box-procura .box-opt').on('click', function(e) {
		e.stopPropagation();
		if ($('.box-logo .procura .box-procura .box-opt ul').hasClass('aberto')) {
			$('.box-logo .procura .box-procura .box-opt ul').removeClass('aberto');
		} else {
			$('.box-logo .procura .box-procura .box-opt ul').addClass('aberto');
		}

	});

	$('.box-logo .procura .box-procura .box-opt ul li').on('click', function(e) {
		e.stopPropagation();
		$('.box-logo .procura .box-procura .box-opt .selecionado ._texto').text($(this).text());
		if ($(this).text() == 'CNPJ') {
			$('.box-inputs').css('display', 'none');
			$('#inp_1').css('display', 'block');
			$('#pesquisa_por_cnpj').val('');
			$('#pesquisa_por_ncm').val('');
		} else if ($(this).text() == 'CNAE') {
			$('.box-inputs').css('display', 'none');
			$('#inp_2').css('display', 'block');
			$('#inp_2 .lista-inputs').html('<input type="text" class="cq" name="cnae" id"pesquisa_por_cnae" placeholder="Informe um CNAE" data-mascara="0000000000">');
			$('#pesquisa_por_cnpj').val('');
			$('#pesquisa_por_ncm').val('');
			habilitaMascara();
		} else if ($(this).text() == 'Produto') {
			$('.box-inputs').css('display', 'none');
			$('#inp_3').css('display', 'block');
			$('#inp_3 .lista-inputs').html('<input type="text" name="nq" id="pesquisa_por_ncm" placeholder="Informe um Produto ou descrição">');
			$('#pesquisa_por_cnpj').val('');
			$('#pesquisa_por_ncm').val('');
		}
		$('.box-logo .procura .box-procura .box-opt ul').removeClass('aberto');
	});

	$('.box-logo .procura .box-procura .box-inputs .bt-mais').on('click', function() {
		if ($('#inp_2 .lista-inputs input').length == 1 || $('#inp_3 .lista-inputs input').length == 1) {
			$('#inp_2 .lista-inputs').html('<input type="text" name="xq" placeholder="Informe um CNAE" style="width:50%"><input type="text" name="cq" placeholder="Informe um CNAE" style="width:50%">');
			$('#inp_3 .lista-inputs').html('<input type="text" name="xq" placeholder="Informe um Produto" style="width:50%"><input type="text" name="cq" placeholder="Informe um Produto" style="width:50%">');
		} else if ($('#inp_2 .lista-inputs input').length == 2 || $('#inp_3 .lista-inputs input').length == 2) {
			$('#inp_2 .lista-inputs').html('<input type="text" name="xq" placeholder="CNAE" style="width:33%"><input type="text" name="nq" placeholder="CNAE" style="width:33%"><input type="text" name="xq" placeholder="CNAE" style="width:33%">');
			$('#inp_3 .lista-inputs').html('<input type="text" name="xq" placeholder="NCM" style="width:33%"><input type="text" name="nq" placeholder="NCM" style="width:33%"><input type="text" name="xq" placeholder="NCM" style="width:33%">');
		}
	});

	$(document.body).on("click", function(e) {
		if (!$(e.target).parents('.box-logo .procura .box-procura .box-opt').find('.aberto').length) {
			$('.box-logo .procura .box-procura .box-opt ul').removeClass('aberto');
		}
	});

	$('.lista-ncms .bt-ncm').on('click', function() {
		$('.lista-ncms .bt-ncm').removeClass('selecionado');
		$(this).addClass('selecionado');
	});

	$('.bloco-branco .bloco-seleciona-cnae').on("click", function() {
		if ($(this).find('input[type="checkbox"]').prop('checked')) {
			$(this).removeClass('bloco-selecionado');
			$(this).find('input[type="checkbox"]').prop('checked', false);
			$('.itens-selecionados').text(parseInt(parseInt($('.itens-selecionados').text()) - 1));
		} else {
			$(this).addClass('bloco-selecionado');
			$(this).find('input[type="checkbox"]').prop('checked', true);
			$('.itens-selecionados').text(parseInt(parseInt($('.itens-selecionados').text()) + 1));
		}
	});

	$('#ncms').on('click', 'td', function() {
		if ($(this).parents('tr').find('input[type="checkbox"]').prop('checked')) {
			$(this).parents('tr').removeClass('linha-selecionada');
			$(this).parents('tr').find('input[type="checkbox"]').prop('checked', false);
			$('.itens-selecionados').text(parseInt(parseInt($('.itens-selecionados').text()) - 1));
		} else {
			$(this).parents('tr').addClass('linha-selecionada');
			$(this).parents('tr').find('input[type="checkbox"]').prop('checked', true);
			$('.itens-selecionados').text(parseInt(parseInt($('.itens-selecionados').text()) + 1));
		}
	});

	// $(".bt-editar-empresa-modal").on("click", function(){
	//     $('#empresa_cnpj_editar').val($(this).parents('tr').find('.data-info-cnpj').text());
	//     $('#empresa_nome_editar').val($(this).parents('tr').find('.data-info-nome').text());
	// });

	$('#pesquisa').on('submit', function() {
		if ($('#pesquisa_por_cnpj').val().length != 18 && $('#pesquisa_por_cnpj').val().length > 0) {
			$('#inp_1').notify("Informe um CNPJ válido", {
				className: 'error'
			});
			return false;
		}
	});

});